import React from 'react';
import { useQuery } from '@apollo/client';
import { useCompanyBranding } from '../../../hooks';
import { Banner as BannerModel, Settings } from '../../../models';
import { GET_SETTINGS } from '../../../graphql/queries';

interface HomeBannerProps {
  bannerName: string;
  fallbackSrc: string;
  srcItem: number;
}

export default function HomeBanner({
  bannerName,
  srcItem,
  fallbackSrc,
}: HomeBannerProps) {
  const [srcImage, setSrcImage] = React.useState<string>('');
  const [companyBranding] = useCompanyBranding();

  const { data: dataSettings } = useQuery<{ settings: Settings[] }>(
    GET_SETTINGS,
    {
      fetchPolicy: 'network-only',
    }
  );

  React.useEffect(() => {
    if (!companyBranding) return;
    const bannerItem = companyBranding?.banners?.find(
      (banner: BannerModel) => banner.seccion === bannerName
    );
    if (bannerItem) {
      setSrcImage(bannerItem.image);
    }
  }, [companyBranding]);

  const src = dataSettings?.settings[0]?.carouselImages[srcItem]?.url;

  return (
    <div className=" flex flex-row bg-center bg-cover mt-20 justify-center items-center">
      {!srcImage ? (
        <img
          alt={`Landing ${bannerName}`}
          src={src || fallbackSrc}
          className="object-cover h-auto w-full"
        />
      ) : (
        <img
          alt={`Landing ${bannerName}`}
          src={srcImage}
          className="object-cover h-auto w-[100%]"
        />
      )}
    </div>
  );
}
